import styles from './styles.module.scss';

import { useContext, useEffect, useState } from 'react';
import { Board } from '../../../components/Board';
import { ModuleOption } from '../../../components/ModuleOption';
import { MODULES, Module } from '../../../modules/config/ModulesList';
import { Agent } from '../../../components/Agent';
import { LogicManagerSidebar } from '../../../components/LogicManagerSidebar';
import { ProfileBox } from '../../../components/ProfileBox';
import {
    getPronoun,
    handleTextVariables,
    hasPermission,
    verifyRoutePermissions
} from '../../../globalFunctions';
import { useNavigate } from 'react-router-dom';
import { Image, User } from '../../../types';
import { LoadingContext } from '../../../providers/LoadingProvider';
import { MessageContext } from '../../../providers/MessageProvider';
import { MessageBox } from '../../../components/MessageBox';
import moment from 'moment';
import TrilogicUserManual from '../../../assets/files/trilogic_manual_do_usuario_v1.pdf';
import { NavButton } from '../../../components/NavButton';
import { BotaoAcessibilidade } from '../../../components/BotaoAcessibilidade';
import  SliderControl  from '../../../components/SliderControl/SliderControl';

import { MenuAcessibilidade } from '../../../components/MenuAcessibilidade';
import { transform } from 'lodash';
import axios from 'axios';
import SelectOption from '../../../components/SelectOption';
import Personagem from '../../../components/Personagem';
import cabeca1 from '../../../components/Personagem/assets/Rosto_Masc.png';
import corpoHomem from '../../../components/Personagem/assets/Roupa_Masc01.png';

import cabelo1 from '../../../components/Personagem/assets/Cabelo1.png';
import calvo from '../../../components/Personagem/assets/Cabelo2.png';
import cabelo3 from '../../../components/Personagem/assets/Cabelo3.png';
import emo from '../../../components/Personagem/assets/Cabelo04.png';

import rostoFeminino from '../../../components/Personagem/assets/Rosto_Fem.png';
import corpoMulher from '../../../components/Personagem/assets/Roupa_Fem01.png';

import roupaX from '../../../components/Personagem/assets/roupaX.png';
import roupaX2 from '../../../components/Personagem/assets/RoupaX2.png';
import roupaX3 from '../../../components/Personagem/assets/RoupaX3.png';
import roupaX4 from '../../../components/Personagem/assets/RoupaX4.png';
import roupaX5 from '../../../components/Personagem/assets/RoupaX5.png';


import cabeloAtras1 from '../../../components/Personagem/assets/Cabelo04_Tras.png';
import cabeloAtras2 from '../../../components/Personagem/assets/CabeloAtras2.png';
import cabeloAtras3 from '../../../components/Personagem/assets/CabeloAtras3.png';


export const CharacterRoute = () => {

    const [userAuth, setUserAuth] = useState<User>({} as User);

    const [cabeloTras, setCabeloTras] = useState<String>(cabeloAtras1);
    const { setIsLoadingPage } = useContext(LoadingContext);

    const [cabelo, setCabelo] = useState<String>(cabelo1);
    const [cabeca, setCabeca] = useState<String>(cabeca1);
    const [corpo, setCorpo] = useState<String>(corpoHomem);
    
    const cabelos = [
        { imagem: cabelo1, left: '-1vw', bottom: '7vw', size: '1.1' },
        { imagem: calvo, left: '0vw', bottom: '5vw', size: '1.1' },
        { imagem: cabelo3, left: '-.25vw', bottom: '7.5vw', size: '1' },
        { imagem: emo, left: '-.5vw', bottom: '7vw', size: '1.1' },
        { imagem: '', left: '', bottom: '', size: '' }
    ];

    const cabelosTras = [
        { imagem: '', left: '0vw', bottom: '6vw', size: '1' },
        { imagem: cabeloAtras1, left: '0vw', bottom: '6vw', size: '1' },
        { imagem: cabeloAtras2, left: '0vw', bottom: '6vw', size: '1' },
        { imagem: cabeloAtras3, left: '0vw', bottom: '6vw', size: '1' }
    ];
    const cabecas = [cabeca1, rostoFeminino];
    const corpos = [corpoHomem, corpoMulher,roupaX,roupaX2,roupaX3,roupaX4,roupaX5];
    const [indexCabelo, setIndexCabelo] = useState<number>(0);
    const [indexCabeloTras, setIndexCabeloTras] = useState<number>(0);
    const [indexCabeca, setIndexCabeca] = useState<number>(0);
    const [indexCorpo, setIndexCorpo] = useState<number>(0);
    const [rotate, setRotate] = useState(0);
    const [luzRotate, setLuzRotate] = useState(100);
    const [pele, setPele] = useState(100);
    const [luzCabelo, setLuzCabelo] = useState(100);
    const [corCabelo, setCorCabelo] = useState(0);
    const [tomOlhos, setTomOlhos] = useState(100);
    const [corOlhos, setCorOlhos] = useState(0);
    const { setOpenMessage, setMessage } = useContext(MessageContext);


    const navigate = useNavigate();
    const [acessivel, setAcessivel] = useState<boolean>(false);
    const ModoAcessivel = () => {
        setAcessivel(!acessivel);
    };
    const [personagem,setPersonagem] = useState({ 
        indiceCabelo : indexCabelo,
indiceRosto : indexCabeca,
indiceCorpo: indexCorpo,
indiceCabeloAtras: indexCabeloTras,
corOlhos: corOlhos,
tomOlhos: tomOlhos,
fkUserId: userAuth.id,
corRoupa: rotate,
tomRoupa: luzRotate,
corCabelo: corCabelo,
tomCabelo: luzCabelo,
tomPele: pele,})

    const [showAcessibilidade, setShowMenu] = useState<boolean>(false);

    const goBackwards = () => {     
            navigate('/');       
    };

    const showUserManual = () => {
        window.open(TrilogicUserManual);
    };

    const showMenuAcessibilidade = () => {
        setShowMenu(!showAcessibilidade);
    };

    useEffect(() => {
        const user = verifyRoutePermissions(['auth', 'email.verified'], navigate);
        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);

    const handleCharacter  = async () => {
        var result 
        setIsLoadingPage(true);
        try {
             result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/personagem/user`,{userId: userAuth.id})
 
            if(result.data == "") {
                navigate("/characterMaker")
            } else {
                console.log(result.data)
                setPersonagem(result.data)
                setIndexCabeca(result.data.indiceRosto)
                setIndexCabelo(result.data.indiceCabelo)
                setIndexCorpo(result.data.indiceCorpo)             
                setIndexCabeloTras(result.data.indiceCabeloAtras)
                setTomOlhos(result.data.tomOlhos)
                setCorOlhos(result.data.corOlhos)
                setPele(result.data.tomPele)
                setLuzCabelo(result.data.tomCabelo)
                setRotate(result.data.corRoupa)
                setIndexCabeloTras(result.data.indiceCabeloAtras)
                setLuzRotate(result.data.tomRoupa)
                setCorCabelo(result.data.corCabelo)
            }

            } catch(error) {
                const response = {
                    message: 'Erro ao buscar status dos módulos',
                    error: error
                };
        
               return response;

        }
        setIsLoadingPage(false);

    }

useEffect(()=> {


handleCharacter()
},[userAuth])
    
    
    useEffect(()=>{


        if(Object.keys(personagem).length>0) {
            let Personagem = {
                indiceCabelo : indexCabelo,
                indiceRosto : indexCabeca,
                indiceCorpo: indexCorpo,
                indiceCabeloAtras: indexCabeloTras,
                corOlhos: corOlhos,
                tomOlhos: tomOlhos,
                fkUserId: userAuth.id,
                corRoupa: rotate,
                tomRoupa: luzRotate,
                corCabelo: corCabelo,
                tomCabelo: luzCabelo,
                tomPele: pele,

            }
            setPersonagem(Personagem)
        } 
        
    },[
        indexCabeca,indexCabelo,indexCabeloTras,
        indexCorpo,tomOlhos,corOlhos,tomOlhos,luzRotate,rotate,corCabelo,luzCabelo,pele,userAuth
    ])

    useEffect(() => {
        document.documentElement.style.setProperty('--valor-rotate', `${personagem.corRoupa}deg`);
        document.documentElement.style.setProperty('--valor-luz-rotate', `${luzRotate}%`);
        document.documentElement.style.setProperty('--valor-pele', `${pele}%`);
        document.documentElement.style.setProperty('--valor-luz-cabelo', `${luzCabelo}%`);
        document.documentElement.style.setProperty('--valor-cor-cabelo', `${corCabelo}deg`);
        document.documentElement.style.setProperty('--valor-tom-olhos', `${personagem.tomOlhos}%`);
        document.documentElement.style.setProperty('--valor-cor-olhos', `${personagem.corOlhos}deg`);
    }, [rotate, luzRotate , pele, luzCabelo, corCabelo , tomOlhos , corOlhos]);

    const saveCharacter = async () => {
        const temPersonagem = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/personagem/user`,{userId: userAuth.id})
        console.log(personagem)
        try {
            if(temPersonagem.data == "") {
                const criou = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/personagem`,personagem)
                console.log("criou")
            } else {
                console.log(personagem)
                const atualizou = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/personagem/`+userAuth.id,personagem)
                console.log("atualizou")
            }

            setMessage({
                type: 'success',
                content: 'Alterações salvas com sucesso'
            });
            setOpenMessage(true);

            navigate("/")

        } catch(erro) {
            setMessage({
                type: 'info',
                content: 'Sem alterações para salvar'
            });
            setOpenMessage(true);
        }
        
    }


    return (
        <div className={styles.wrapper}>
            {userAuth.token && (
                <>
                    <ProfileBox user={userAuth} />
                    <NavButton
                        icon='quick_reference_all'
                        style={{ right: '1vw', bottom: '50vw', zIndex: '20' }}
                        onClick={showUserManual}
                        title='Mostrar manual'
                    />
                    <Board wrapperClass={styles.board}>
                        <h1 className={styles.title}>Editor de personagem</h1>
                        <div className="leftSide" style={{ float: 'left' }}>
                            <SelectOption nameOption="Cabelo⠀⠀⠀⠀" index={indexCabelo} setIndex={setIndexCabelo} options={cabelos} />
                            <SelectOption nameOption="Cabelo Atrás" index={indexCabeloTras} setIndex={setIndexCabeloTras} options={cabelosTras} />
                            <SelectOption nameOption="Cabeça⠀⠀⠀⠀ " index={indexCabeca} setIndex={setIndexCabeca} options={cabecas} />
                            <SelectOption nameOption="Corpo⠀⠀⠀⠀⠀" index={indexCorpo} setIndex={setIndexCorpo} options={corpos} />
                        </div>
                        <div className="rightSide" style={{ float: 'right' }}>
                            <Personagem className={''} Personagem={personagem}/>
                        </div>         
                     
                     {/* Sliders Mágicos*/}
                    <div className={styles.sliders}>
                     
                        <SliderControl label="Cor da Roupa" min={0} max={360} value={rotate} onChange={setRotate} />
                        <SliderControl label="Tom da Roupa" min={0} max={200} value={luzRotate} onChange={setLuzRotate} />
                        <SliderControl label="Tom da Pele" min={0} max={200} value={pele} onChange={setPele} />
                        <SliderControl label="Tom do Cabelo" min={0} max={200} value={luzCabelo} onChange={setLuzCabelo} />
                        <SliderControl label="Cor do Cabelo" min={0} max={360} value={corCabelo} onChange={setCorCabelo} />
                        <SliderControl label="Cor dos Olhos" min={0} max={360} value={corOlhos} onChange={setCorOlhos} />
                        <SliderControl label="Tom dos Olhos" min={0} max={360} value={tomOlhos} onChange={setTomOlhos} />
                    
                    </div>      
                    <button onClick={saveCharacter} className={styles.salvarBotao}>Salvar</button>
         
                    </Board>
                    <BotaoAcessibilidade clicar={() => setShowMenu((current) => !current)} />
                    {showAcessibilidade && (
                        <MenuAcessibilidade ModoAcessivel={ModoAcessivel} OnPress={showMenuAcessibilidade} acessivel={acessivel} />
                    )}

                  
                </>
            )}

                  <NavButton
                            direction='left'
                            style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
                            onClick={goBackwards}
                            /> 



        </div>



    );
};
